import React, { useEffect, useState } from "react";
import { ud, jwt, SERVER_IP, auth_response_flow } from "../../Server";
import axios from "axios";
import NoDataFound from "../../common/NoDataFound";

function buildNestedStructure(data, parentId = 0) {
  return data
    .filter((item) => item.parent_id === parentId)
    .map((item) => ({
      ...item,
      children: buildNestedStructure(data, item.id),
    }));
}

const ImportFromLibrary = ({ libraryType, handleImportClick = null, handleChange }) => {
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [libraryQuestionList, setLibraryQuestionList] = useState([]);

  const renderRecursiveTree = (tree, inputId) => {
    return tree.map((question) => (
      <div className="hierarchylist" id={question.id}>
        <label htmlFor={inputId}>{question?.question || "N/A"}</label>
        {question.children?.length > 0 && renderRecursiveTree(question.children || [], inputId)}
      </div>
    ));
  };

  const onImportClick = (e) => {
    if (handleImportClick) {
      handleImportClick(e, true);
    }
  };

  const getList = () => {
    var data = {
      sid: ud.main_id,
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/${libraryType}`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          let list = [];
          if (libraryType === "MCQList") {
            list = response.data?.listMCQ || [];
          }
          if (libraryType === "RangeList") {
            list = response.data?.listRange || [];
          }
          if (libraryType === "ParentChildList") {
            const listHierarchy = buildNestedStructure(response.data?.listParentchild || []);
            list = listHierarchy;
          }
          setLibraryQuestionList(list);
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              getList();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleTypeChange = (question) => {
    setSelectedQuestion(question);
    handleChange(libraryType, question);
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className="librarysection">
      <div className="workflowheading d-flex align-items-center justify-content-between">
        <h4>Import from Library</h4>
        {selectedQuestion && (
          <div className="mt-3">
            <button className="btn btn-primary btn-sm" onClick={onImportClick}>
              + Add to workflow
            </button>
          </div>
        )}
      </div>

      {libraryQuestionList?.length === 0 && <NoDataFound headText="No data found" />}
      <div className="libraryquestionlist pl-1">
        {libraryQuestionList.map((question) => {
          const inputId = `customRadio${question.id}`;
          return (
            <div className="custom-control custom-radio" key={question.id}>
              <input
                type="radio"
                id={inputId}
                name="mcqBankRadio"
                className="custom-control-input"
                value={question.id}
                checked={selectedQuestion?.id === question.id}
                onChange={() => handleTypeChange(question)}
              />

              <label className="custom-control-label" htmlFor={inputId}>
                {question.question}
              </label>
              {question.children?.length > 0 && renderRecursiveTree(question?.children || [], inputId)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImportFromLibrary;
